module.exports = __webpack_public_path__ + "img/inn5.7fc3517d.jpg";